import React, { useEffect, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  FlatList,
  TextInput,
  ScrollView,
} from "react-native";
import Dawer from "../../component/drawer";
import Admin from "../../component/admin";
import { FontAwesome5, AntDesign } from "@expo/vector-icons";
import Calendar from "react-calendar";
import moment from "moment";
import Page0 from "./page0";
import Page1 from "./page1";
import Page2 from "./page2";
import { apiservice } from "../../service/service";
import { useRecoilValue } from "recoil";
import { tokenState } from "../../reducer/reducer/reducer/Atom";
import { getevent } from "../../action/actionGet";
const { width, height } = Dimensions.get("window");
export default function report({ navigation }) {
  const [page, setpage] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [locate, setLo] = useState({});
  const [handelCalendar, setHandelCalendar] = useState(false);
  const [dateState, setDateState] = useState(new Date());
  const [day, setday] = useState(new Date());
  const changeDate = (e) => {
    setDateState(e);
  };
  const token = useRecoilValue(tokenState);
  const [locate1, setLo1] = useState({});
  const [handelCalendar1, setHandelCalendar1] = useState(false);
  const [Event, setEvent] = useState(false);
  const [Eventlist, setEventlist] = useState([]);
  const [getReport, setReport] = useState([]);
  const [getReport1, setReport1] = useState([]);
  const [getReport2, setReport2] = useState([]);
  const [search, setsearch] = useState("");
  const [dateState1, setDateState1] = useState(new Date());
  const [day1, setday1] = useState(new Date(moment()?.add(1, "months")));

  const changeDate1 = (e) => {
    setDateState1(e);
  };

  const handleScroll = (event) => {
    const { layoutMeasurement, contentOffset, contentSize } = event.nativeEvent;
    const paddingToBottom = 20;

    // Check if scrolled to bottom
    if (layoutMeasurement.height + contentOffset.y >= contentSize.height - paddingToBottom) {
      // Auto advance to next page
      // Only load more if there's more data
      if (hasMore) {
        setPageNumber((prev) => prev + 1);
      }
    }
  };

  useEffect(() => {
    // Reset pageNumber when dates or search change
    setPageNumber(1);
    setReport([]);
    setReport1([]);
    setReport2([]);
    setHasMore(true);
  }, [day, day1, search]);

  useEffect(() => {
    apicall();
  }, [day, day1, pageNumber, search]);

  async function apicall() {
    let hasMoreSupply = false;
    let hasMoreVatTrue = false;
    let hasMoreVatFalse = false;
    const searchQuery = `&search=${encodeURIComponent(search || "")}`;

    const resolveHasMore = (response, fallbackLength) => {
      const currentPage = Number(response?.data?.pagination?.page || pageNumber);
      const totalPages = Number(response?.data?.pagination?.totalPages || 0);

      if (totalPages > 0) {
        return currentPage < totalPages;
      }

      return fallbackLength >= 20;
    };

    const events = await getevent()

    setEventlist(events?.data?.data?.map((item) => ({ ...item, event_name: item.titel })) || []);

    const res = await apiservice({
      path:
        "/admin/getreport" +
        "?start=" +
        moment(day)?.format("YYYY-MM-DD") +
        "&end=" +
        moment(day1)?.format("YYYY-MM-DD") +
        "&page=" +
        pageNumber +
        searchQuery,
      token: token?.accessToken,
    });
    if (res?.status == 200) {
      const newData = res?.data?.data || [];
      setReport((prev) => [...prev, ...newData]);
      console.log(newData);
      hasMoreSupply = resolveHasMore(res, newData.length);

      const allData = [...getReport, ...newData];
      const eventData = allData.filter(
        (thing, index, self) =>
          index === self.findIndex((t) => t.event_name === thing.event_name)
      );
      // setEventlist(eventData);
    }

    const res1 = await apiservice({
      path:
        "/admin/getreport_vat" +
        "?start=" +
        moment(day)?.format("YYYY-MM-DD") +
        "&end=" +
        moment(day1)?.format("YYYY-MM-DD") +
        "&page=" +
        pageNumber +
        "&chack_vat=true" +
        searchQuery,
      token: token?.accessToken,
    });

    if (res1?.status == 200) {
      const newData1 = res1?.data?.data || [];
      setReport1((prev) => [...prev, ...newData1]);
      console.log(newData1);
      hasMoreVatTrue = resolveHasMore(res1, newData1.length);
    }

    const res2 = await apiservice({
      path:
        "/admin/getreport_vat" +
        "?start=" +
        moment(day)?.format("YYYY-MM-DD") +
        "&end=" +
        moment(day1)?.format("YYYY-MM-DD") +
        "&page=" +
        pageNumber +
        "&chack_vat=false" +
        searchQuery,
      token: token?.accessToken,
    });

    if (res2?.status == 200) {
      const newData2 = res2?.data?.data || [];
      setReport2((prev) => [...prev, ...newData2]);
      hasMoreVatFalse = resolveHasMore(res2, newData2.length);
    }

    setHasMore(hasMoreSupply || hasMoreVatTrue || hasMoreVatFalse);
  }

  const handleExport = () => {
    const searchQuery = `&search=${encodeURIComponent(search || "")}`;

    if (page == 0) {
      window.open(
        "https://api-sosorun.asiaconnectth.com/api/imaged/getxlxesupply" +
        "?start=" +
        moment(day)?.format("YYYY-MM-DD") +
        "&end=" +
        moment(day1)?.format("YYYY-MM-DD") +
        "&page=" +
        pageNumber +
        "&chack_vat=false" +
        searchQuery,
      );

      return
    }

    if (page == 1) {
      window.open(
        "https://api-sosorun.asiaconnectth.com/api/imaged/getxlxesupply" +
        "?start=" +
        moment(day)?.format("YYYY-MM-DD") +
        "&end=" +
        moment(day1)?.format("YYYY-MM-DD") +
        "&page=" +
        pageNumber +
        "&chack_vat=false" +
        searchQuery,
      );

      return;
    }

    window.open(
      "https://api-sosorun.asiaconnectth.com/api/imaged/getxlxesupply" +
      "?start=" +
      moment(day)?.format("YYYY-MM-DD") +
      "&end=" +
      moment(day1)?.format("YYYY-MM-DD") +
      "&page=" +
      pageNumber +
      "&chack_vat=false" +
      searchQuery,
    );
  };

  return (
    <View style={styles.container}>
      <Dawer navigation={navigation} />
      <ScrollView
        onScroll={handleScroll}
        scrollEventThrottle={16}
      >
        <View style={styles.back}>
          <Admin />
          <Text style={styles.textfree}>REPORT</Text>
          <View style={[styles.viewfree, { width: width * 0.5 }]}>
            <TouchableOpacity
              onPress={() => setpage(0)}
              style={[
                styles.touch,
                { backgroundColor: page == 0 ? "#FCC81D" : "#fff" },
              ]}
            >
              <Text style={styles.textadd}>รายงานการจัดส่ง</Text>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => setpage(1)}
              style={[
                styles.touch,
                { backgroundColor: page == 1 ? "#FCC81D" : "#fff" },
                { width: 250 },
              ]}
            >
              <Text style={styles.textadd}>รายงานการออกใบเสร็จ/กำกับภาษี</Text>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => setpage(2)}
              style={[
                styles.touch,
                { backgroundColor: page == 2 ? "#FCC81D" : "#fff" },
              ]}
            >
              <Text style={styles.textadd}>สรุปรายงานการเงิน</Text>
            </TouchableOpacity>
          </View>
          <View
            style={[
              styles.viewfree,
              { backgroundColor: "#FCC81D50" },
              { padding: 5 },
            ]}
          >
            <View
              style={{
                width: width * 0.45,
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Text style={styles.textadd}>ตั้งแต่วันที่</Text>
              <View style={{ flexDirection: "row" }}>
                <TextInput
                  style={styles.touch1}
                  placeholder="เริ่ม"
                  date="show"
                  type={true}
                  locate={locate}
                  setLo={setLo}
                  setHandelCalendar={setHandelCalendar}
                  value={moment(day).format("DD/MM/YYYY")}
                />

                <TouchableOpacity
                  onPress={() => {
                    setHandelCalendar((val) => !val);
                  }}
                  style={styles.botton1}
                >
                  <FontAwesome5 name="calendar-alt" size={18} color="#AFAFAF" />
                </TouchableOpacity>
              </View>
              <Text style={styles.textadd}>ถึงวันที่</Text>
              <View style={{ flexDirection: "row" }}>
                <TextInput
                  style={styles.touch1}
                  placeholder="สิ้นสุด"
                  date="show1"
                  type={true}
                  locate1={locate1}
                  setLo1={setLo1}
                  setHandelCalendar1={setHandelCalendar1}
                  value={moment(day1).format("DD/MM/YYYY")}
                />
                <TouchableOpacity
                  onPress={() => {
                    setHandelCalendar1((val) => !val);
                  }}
                  style={styles.botton1}
                >
                  <FontAwesome5 name="calendar-alt" size={18} color="#AFAFAF" />
                </TouchableOpacity>
              </View>
              <TouchableOpacity
                style={{
                  width: 60,
                  height: 30,
                  backgroundColor: "#4B4B48",
                  borderRadius: 5,
                  justifyContent: "center",
                }}
              >
                <AntDesign
                  name="search1"
                  size={24}
                  color="#fff"
                  style={{ alignSelf: "center" }}
                />
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => handleExport()}
                style={{
                  width: 80,
                  height: 30,
                  backgroundColor: "#4B4B48",
                  borderRadius: 5,
                  justifyContent: "center",
                }}
              >
                <Text style={[styles.textadd, { color: "#fff" }]}>EXPORT</Text>
              </TouchableOpacity>
              <View>
                <TouchableOpacity
                  onPress={() => {
                    setEvent(!Event);
                  }}
                  style={{
                    width: 150,
                    height: 30,
                    backgroundColor: "#4B4B48",
                    borderRadius: 5,
                    justifyContent: "center",
                  }}
                >
                  <Text
                    numberOfLines={1}
                    style={[styles.textadd, { color: "#fff" }]}
                  >
                    {search != "" ? search : "เลือกรายการ Event"}
                  </Text>
                </TouchableOpacity>

                {Event && (
                  <View
                    style={{
                      width: 300,
                      borderWidth: 1,
                      borderColor: "#CCC",
                      position: "absolute",
                      marginTop: 40,
                      zIndex: 99,
                      backgroundColor: "#fff",
                    }}
                  >
                    <FlatList
                      data={Eventlist}
                      style={{ height: 300 }}
                      renderItem={({ index, item }) => {
                        return (
                          <TouchableOpacity
                            onPress={() => {
                              setEvent(false);
                              setsearch(item.titel);
                            }}
                            style={{ paddingHorizontal: 10 }}
                          >
                            <Text
                              numberOfLines={1}
                              style={{
                                fontSize: 18,
                                fontFamily: "Prompt-Regular",
                                color: "#00000080",
                              }}
                            >
                              {item.event_name}
                            </Text>
                          </TouchableOpacity>
                        );
                      }}
                    />
                  </View>
                )}
              </View>
            </View>
          </View>
          {page == 0 && (
            <Page0
              getReport={getReport}
            />
          )}
          {page == 1 && (
            <Page1
              getReport={getReport1}
            />
          )}
          {page == 2 && (
            <Page2
              getReport={getReport2}
            />
          )}
        </View>
      </ScrollView>
      {handelCalendar && (
        <View
          style={{
            width: width * 0.18,
            position: "absolute",
            zIndex: 99,
            top: 210,
            left: 210,
          }}
        >
          <Text
            style={{
              fontSize: 10,
              color: "#000",
              textAlign: "center",
              fontFamily: "Prompt-Regular",
            }}
          >
            <Calendar
              value={dateState}
              onClickDay={(e) => {
                setday(e);
                setTimeout(() => {
                  setHandelCalendar((val) => !val);
                }, 500);
              }}
            />
          </Text>
        </View>
      )}
      {handelCalendar1 && (
        <View
          style={{
            width: width * 0.18,
            position: "absolute",
            zIndex: 99,
            top: 210,
            left: 455,
          }}
        >
          <Text
            style={{
              fontSize: 10,
              color: "#000",
              textAlign: "center",
              fontFamily: "Prompt-Regular",
            }}
          >
            <Calendar
              value={dateState1}
              onClickDay={(a) => {
                setday1(a);
                setTimeout(() => {
                  setHandelCalendar1((val) => !val);
                }, 500);
              }}
            />
          </Text>
        </View>
      )}
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    width: width,
    height: height,
    backgroundColor: "#F3F3F3",
    flexDirection: "row",
    zIndex: -99,
  },
  back: {
    width: width * 0.845,
    height: height,
    paddingHorizontal: width * 0.01,
  },
  viewfree: {
    justifyContent: "space-between",
    width: width * 0.825,
    flexDirection: "row",
    marginTop: 10,
  },
  textfree: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#000",
    fontWeight: "bold",
  },
  touch: {
    width: 200,
    height: 40,
    justifyContent: "center",
    borderRadius: 5,
    borderWidth: 0.5,
    borderColor: "#8898AA",
  },
  textadd: {
    fontFamily: "Prompt-Regular",
    fontSize: 14,
    color: "#172B4D",
    alignSelf: "center",
  },
  touch1: {
    width: width * 0.1,
    height: 30,
    borderWidth: 0.5,
    borderColor: "#8898AA",
    borderRadius: 5,
    paddingLeft: 20,
    backgroundColor: "#fff",
  },
  botton1: {
    alignSelf: "flex-end",
    padding: 5,
    marginLeft: -30,
  },
});
